import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/enterpriseAuth/apply',
    name: 'enterpriseAuthApply',
    component: () => import('@/sub-app/enterpriseAuth/pages/apply.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: true,
    },
  },
  {
    path: '/enterpriseAuth/applyResult',
    name: 'enterpriseAuthResult',
    component: () => import('@/sub-app/enterpriseAuth/pages/applyResult.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: true,
    },
  },
  {
    path: '/enterpriseAuth/authList',
    name: 'enterpriseAuthauthList',
    component: () => import('@/sub-app/enterpriseAuth/pages/authList.vue'),
    meta: {
      title: '员工认证', 
      keepAlive: true,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  document.title = to.meta?.title || '';
  next();
});

export default router;
